import { useQuery } from '@tanstack/react-query';
import { notificationService } from '../services/notificationService';
import { NotificationQuery } from '@troia-v3/types';

/**
 * Hook to fetch user's notifications with pagination and filters
 */
export const useNotifications = (query?: NotificationQuery) => {
  return useQuery({
    queryKey: ['notifications', query],
    queryFn: () => notificationService.getMyNotifications(query),
    staleTime: 1 * 60 * 1000, // 1 minute
    refetchInterval: 30 * 1000, // Auto-refresh every 30 seconds
  });
};
